import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './theme.css';
import { ThemeProvider } from './pages/ThemeContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
<script src="https://cdn.jsdelivr.net/npm/sweetalert2@11"></script>

root.render(
  <React.StrictMode>
<ThemeProvider><App /></ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
